import { Toast } from "react-hot-toast";

export type ToastArgs =
  | Partial<
      Pick<
        Toast,
        | "id"
        | "style"
        | "className"
        | "position"
        | "icon"
        | "duration"
        | "ariaProps"
        | "iconTheme"
      >
    >
  | undefined;

// gloabl toast styles
export const toastSuccess = {
  position: "bottom-right",
  duration: 1500,
  style: {
    borderRadius: "var(--border-radius)",
    boxShadow: "0px 8px 8px 0px #191E26",
    border: "none",
    padding: "16px",
    color: "var(--text-color-primary)",
    background: "var(--toast-background-color-primary)",
    fontSize: "12px",
  },
} as ToastArgs;

export const toastFail = {
  position: "bottom-right",
  duration: 3000,
  style: {
    borderRadius: "var(--border-radius)",
    boxShadow: "0px 8px 8px 0px #191E26",
    border: "none",
    padding: "16px",
    color: "var(--text-color-primary)",
    background: "var(--toast-background-color-fail)",
    fontSize: "12px",
  },
} as ToastArgs;

export const toastPersist = {
  position: "bottom-right",
  duration: 150000,
  style: {
    borderRadius: "var(--border-radius)",
    boxShadow: "0px 8px 8px 0px #191E26",
    padding: "16px",
    color: "var(--text-color-primary)",
    background: "var(--toast-background-color-persist)",
    fontSize: "12px",
  },
} as ToastArgs;

export const toastInfo = {
  position: "bottom-right",
  duration: 1500,
  style: {
    border: "1px solid white",
    padding: "16px",
    color: "white",
    background: "#5C10E4",
  },
} as ToastArgs;

